import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_5 = [
  _hoisted_4
]

import { getInstitutionTeacherCoursewareShareRecord } from '@/services/audit-management'
import { debounce } from '@/utils/common'
import {
  ref,
  computed,
  toRaw,
  onMounted
} from 'vue'
import { TableTabMap, CoursewareTypeMap } from '../../config'
import { PermissionMap } from '@/utils/auth'


export default /*#__PURE__*/_defineComponent({
  props: {
  formData: {
    type: Object
  },
  contextPage: {
    type: Number,
    default: () => 1
  }
},
  emits: ['onPreview', 'update:contextPage'],
  setup(__props, { expose, emit }) {

const props = __props




// 搜索表单数据
const formDataCompu = computed(() => props.formData || {})
// table数据
const tableData = ref<any[]>([])
// 加载状态
const loading = ref<boolean>(false)

// 分页信息
const pagination = ref({
  current: 1,
  total: 1,
  pageSize: 10,
  showTotal: (total: number) => `共${total}条`,
  showQuickJumper: true
})

const contPage = ref<number>(props.contextPage)

const columns = [
  {
    title: '编号',
    dataIndex: 'id',
    width: 80,
    ellipsis: true
  },
  {
    title: '课件名称',
    dataIndex: 'name',
    width: 120,
    ellipsis: true
  },
  {
    title: '课件类型',
    dataIndex: 'type',
    width: 100,
    slots: { customRender: 'type' }
  },
  {
    title: '所属教材',
    dataIndex: ['book', 'name'],
    width: 180,
    ellipsis: true
  },
  {
    title: '所属章节',
    dataIndex: 'section_breadcrumb',
    width: 180,
    ellipsis: true
  },
  {
    title: '作者',
    dataIndex: 'teacher_name',
    width: 100,
    ellipsis: true
  },
  {
    title: '所属学校',
    dataIndex: 'teacher_school_name',
    width: 120,
    ellipsis: true
  },
  {
    title: '提交时间',
    dataIndex: 'created_at',
    width: 180
  },
  {
    title: '审核时间',
    dataIndex: 'audited_at',
    width: 180,
    ellipsis: true
  },
  {
    title: '审核意见',
    dataIndex: 'audit_note',
    slots: { customRender: 'audit_note' },
    width: 180,
    ellipsis: true
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 120,
    slots: { customRender: 'action' }
  }
]

// 获取待审核列表
const getShareWaitAuditRecord = debounce(async (params: any) => {
  const qParams = {
    ...toRaw(formDataCompu.value),
    page: pagination.value.current,
    ...params,
    status: TableTabMap.FAIL
  }
  try {
    loading.value = true
    const { items, meta } = await getInstitutionTeacherCoursewareShareRecord(
      qParams
    )
    tableData.value = items
    pagination.value = {
      ...toRaw(pagination.value),
      ...meta,
      current: meta.current_page
    }
    loading.value = false
  } catch (error) {
    console.log(error)
    tableData.value = []
    loading.value = false
  }
})

// 表格变化时
const handleTableChange = (page: any) => {
  pagination.value = page
  getShareWaitAuditRecord({ page: page.current })
}

// 搜索操作
const handleSearch = (changePage = true) => {
  if (changePage) {
    pagination.value.current = 1
  }
  getShareWaitAuditRecord({})
}

const handlePreview = (record: any) => {
  console.log('提交预览请求给父组件')
  emit('onPreview', record)
}

expose({
  handleSearch,
  getCurrentPage: () => pagination.value.current
})

onMounted(() => {
  if (contPage.value > 1) {
    pagination.value.current = contPage.value
    handleSearch(false)
    emit('update:contextPage', 1)
  } else {
    handleSearch()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!
  const _directive_permission_in_slot = _resolveDirective("permission-in-slot")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_table, {
      dataSource: tableData.value,
      columns: columns,
      rowKey: "id",
      pagination: pagination.value,
      loading: loading.value,
      onChange: handleTableChange,
      scroll: { x: 1300 }
    }, {
      type: _withCtx(({text}) => [
        _createElementVNode("span", null, _toDisplayString(_unref(CoursewareTypeMap)[text] || text), 1)
      ]),
      audit_note: _withCtx(({text}) => [
        _createElementVNode("span", null, [
          (text && text.length > 10)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createVNode(_component_a_tooltip, { title: text }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(text.slice(0, 9)) + "...", 1)
                  ]),
                  _: 2
                }, 1032, ["title"])
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(text), 1))
        ])
      ]),
      action: _withCtx(({record}) => [
        _withDirectives(_createElementVNode("a", {
          onClick: () => handlePreview(record)
        }, _hoisted_5, 8, _hoisted_3), [
          [_directive_permission_in_slot, _unref(PermissionMap).AUDIT_MANAGEMENT_INSTITUTION_PREVIEW]
        ])
      ]),
      _: 1
    }, 8, ["dataSource", "pagination", "loading"])
  ]))
}
}

})